import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitosaputara() {



  const cardData =
  {
    keyword: 'Mumbai to Saputara Cabs',
    heading: 'Shambhu Cabs: Mumbai to Saputara Cabs',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Saputara Cabs, providing safe, comfortable, and hassle-free travel for families, friends, tourists, and weekend getaway seekers heading to the scenic hill station of Saputara. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Saputara with spacious seating and clean interiors. With flexible one-way and round-trip options, experienced chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes your hill-station trip convenient, stress-free, and enjoyable. For trusted, comfortable, and safe travel, Shambhu Cabs is your preferred choice for Mumbai to Saputara cab services.',

    top: 'Top Places to Visit in Saputara with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Saputara Lake",
    "description": "Saputara Lake is the heart of the hill station and one of the most scenic freshwater lakes in Gujarat’s only hill destination. Surrounded by lush green hills, walking paths, and garden landscapes, the lake is ideal for boating, leisure strolls, photography, and enjoying cool mountain breezes. During evenings, the lakefront comes alive with food stalls, handicraft shops, and soft golden lighting reflecting on the water, making it a relaxing hub for tourists. It is the perfect starting point for exploring Saputara’s tranquil natural beauty."
  },
  {
    "title": "Sunset Point (Gandhi Shikhar)",
    "description": "Sunset Point, also known as Gandhi Shikhar, is the most popular viewpoint in Saputara offering breathtaking panoramic views of the Dang forest ranges. As the sun sets, the horizon glows with hues of orange and gold, making it a magical sight. A ropeway ride is also available nearby, offering an aerial view of the hills, lake, and valleys. The calm surroundings and gentle winds make this viewpoint a favorite spot for nature lovers, photographers, and families seeking scenic relaxation."
  },
  {
    "title": "Sunrise Point (Valley View Point)",
    "description": "Situated at a higher altitude, Sunrise Point offers a serene and refreshing environment perfect for watching the early morning sun rise above the lush green valleys. The viewpoint provides a 360-degree view of the surrounding hills, forests, and mist-covered landscapes. A short hike or drive leads visitors to this peaceful spot, making it ideal for meditation, photography, and enjoying the pure mountain air. The sight of golden sunlight breaking through the mist creates a memorable experience."
  },
  {
    "title": "Saputara Ropeway",
    "description": "The Saputara Ropeway is one of the main attractions of the hill station, offering an exciting aerial view of the valley, lake, and forests. The cable car ride connects Sunset Point to the Governor’s Hill region and provides a thrilling experience for visitors of all ages. During the ride, travelers witness sweeping landscapes, lush greenery, and the peaceful charm of the Sahyadri mountains. It is one of the best ways to appreciate Saputara’s natural beauty from above."
  },
  {
    "title": "Gira Waterfalls",
    "description": "Located near Waghai, Gira Waterfalls is a spectacular natural attraction especially popular during the monsoon when the water flow is at its peak. The waterfall cascades dramatically from a height into a rocky pool surrounded by dense forests. Visitors enjoy photography, picnics, and trekking trails in the area. The misty atmosphere, roaring sound of the falls, and lush green surroundings make Gira Waterfalls a perfect nature escape for tourists exploring the Saputara region."
  },
  {
    "title": "Governor’s Hill",
    "description": "Governor’s Hill is a peaceful scenic hilltop offering panoramic views of Saputara’s valleys and forests. Visitors can trek or walk up the gentle slopes, enjoying greenery and cool breezes. The hilltop is spacious, open, and perfect for spending quality time, capturing scenic photographs, and watching the city lights at dusk. It is less crowded than other points, making it ideal for those seeking quiet natural beauty and relaxation."
  },
  {
    "title": "Artist Village",
    "description": "Artist Village in Saputara is a cultural hub showcasing tribal art, Warli paintings, bamboo crafts, and traditional hand-made items created by local artisans. Visitors can interact with craftsmen, watch live demonstrations, purchase unique souvenirs, and learn about the Dang tribal culture. The center also conducts workshops, making it an enriching experience for art lovers and culture enthusiasts. It plays a key role in preserving the region’s indigenous heritage."
  },
  {
    "title": "Step Garden",
    "description": "Step Garden is a beautifully designed garden built on different terrace levels, featuring flower beds, stone pathways, ornamental plants, and shaded seating areas. Its unique multi-level structure makes it an excellent spot for leisurely walks, photography, and spending time with family. The garden is well-maintained and offers picturesque views of the hill station. Its calm environment and creatively designed green spaces add charm to Saputara’s scenic attractions."
  },
  {
    "title": "Rose Garden",
    "description": "The Rose Garden is a serene and colorful attraction featuring a large variety of roses and ornamental flowers arranged in beautiful patterns. The landscaped lawns, walking paths, and pleasant floral fragrance make it a relaxing spot for tourists. It is especially popular among families and couples who enjoy the botanical beauty and peaceful ambiance. The seasonal bloom enhances the garden’s charm, making it a delight for nature lovers and photographers."
  },
  {
    "title": "Table Point (Table Land)",
    "description": "Table Point, a flat plateau at the top of a hill, offers stunning panoramic views of Saputara’s lush valleys and surrounding mountains. Visitors can enjoy horse riding, ATV rides, camel rides, and adventure activities. The open space is ideal for photography, relaxing with friends, and watching beautiful sunsets. Its combination of adventure and natural beauty makes it one of the most vibrant and enjoyable tourist spots in Saputara."
  },
  {
    "title": "Waghai Botanical Garden",
    "description": "Located near Saputara, Waghai Botanical Garden is one of Gujarat’s largest botanical parks, featuring rare plant species, medicinal herbs, fruit trees, and a variety of flowering plants. The garden’s peaceful walking trails, educational displays, and shaded resting areas make it an excellent spot for nature education and leisurely exploration. It is ideal for families, students, and nature enthusiasts wanting to learn about regional biodiversity."
  }
],



"services": [
  {
    "name": "Mumbai Saputara Taxi",
    "description": "Mumbai Saputara Taxi offers a smooth and comfortable ride from Mumbai to the popular hill station of Saputara. This service is perfect for travellers seeking a relaxing journey through scenic ghats, cool climates, and lush landscapes. With clean, well-maintained cabs and professional chauffeurs, passengers enjoy a safe and stress-free road trip. This service is ideal for families, couples, solo travellers, and tourists heading for a peaceful getaway to Saputara."
  },
  {
    "name": "Saputara From Mumbai Cab Booking",
    "description": "Saputara From Mumbai Cab Booking provides easy online and offline booking options for travellers planning a visit to Gujarat’s famous hill station. This service ensures quick confirmations, transparent fares, and doorstep pickup for complete convenience. Whether planning a weekend retreat, family holiday, or sightseeing tour, booking a cab from Mumbai to Saputara guarantees reliable travel with experienced drivers and comfortable vehicles."
  },
  {
    "name": "Mumbai to Saputara One Way Cab",
    "description": "Mumbai to Saputara One Way Cab is a cost-effective travel option for those who need one-time travel without a return journey. With affordable fares, clean cars, and expert drivers, this service ensures a smooth and safe ride through scenic routes. Ideal for travellers staying longer in Saputara, those relocating, or those planning onward travel, the one-way cab service offers complete flexibility and convenience."
  },
  {
    "name": "Intercity Cab Mumbai Saputara",
    "description": "Intercity Cab Mumbai Saputara provides a dependable long-distance travel option for tourists and families travelling between the two destinations. With GPS-enabled cars, AC comfort, and long-route trained drivers, passengers experience a smooth hill station journey. This service is tailored for those who value safety, punctuality, and premium travel quality during intercity trips."
  },
  {
    "name": "Best Taxi Mumbai Saputara",
    "description": "Best Taxi Mumbai Saputara offers top-rated, comfortable, and premium cab options for travellers heading to Saputara Hill Station. Known for high customer satisfaction, punctual pickup, and smooth driving experience, the service stands out for its reliability. Clean cars, professional behaviour, and safe hill-route driving make it the preferred choice for tourists seeking a hassle-free journey."
  },
  {
    "name": "Mumbai Saputara Car Rental",
    "description": "Mumbai Saputara Car Rental provides sedan, SUV, and premium car options for long-distance travel to Saputara. This service is ideal for those planning multi-day trips, sightseeing tours, or extended stays at the hill station. Passengers enjoy flexible rental durations, customized itineraries, and professional chauffeurs who are familiar with hill terrain routes and tourist attractions."
  },
  {
    "name": "Affordable Saputara Cab",
    "description": "Affordable Saputara Cab service ensures budget-friendly travel without compromising on comfort or safety. With economical pricing, fuel-efficient cars, and transparent billing, this service is great for students, small families, or group travellers. Despite being affordable, the service maintains high standards of cleanliness, safety, and professional driving."
  },
  {
    "name": "Sedan Cab Mumbai Saputara",
    "description": "Sedan Cab Mumbai Saputara provides comfortable, air-conditioned sedan vehicles ideal for couples, small groups, and business travellers. Sedans offer smooth rides on highways and ghats, making the journey relaxing and enjoyable. With economical fares and high comfort levels, this service suits those seeking a pocket-friendly yet premium travel experience."
  },
  {
    "name": "SUV Cab Mumbai Saputara",
    "description": "SUV Cab Mumbai Saputara offers spacious and powerful vehicles like Ertiga, Innova, and Crysta for travellers who prefer comfort and extra space. These vehicles are ideal for families, larger groups, or travellers carrying extra luggage. SUVs handle hill station routes effortlessly, ensuring safety and comfort throughout the journey."
  },
  {
    "name": "Family Cab Mumbai Saputara",
    "description": "Family Cab Mumbai Saputara is designed especially for family trips, providing spacious seating, child-friendly comfort, and safe driving by trained chauffeurs. Families enjoy a smooth travel experience with multiple halts, flexible scheduling, and luggage-friendly vehicles. Perfect for vacations, sightseeing tours, and peaceful hill station getaways."
  },
  {
    "name": "24x7 Cab Mumbai Saputara",
    "description": "24x7 Cab Mumbai Saputara ensures round-the-clock availability for passengers travelling at any hour of the day. Whether for early morning departures or late-night travel, this service guarantees reliable, safe, and convenient cab access. With immediate booking confirmation and quick customer support, passengers enjoy complete flexibility."
  },
  {
    "name": "Mumbai Saputara Hillstation Cab",
    "description": "Mumbai Saputara Hillstation Cab offers a specially-tailored service for tourists visiting the cool and scenic hill station. Drivers experienced in hill terrains ensure smooth navigation through curves and ghats. Passengers enjoy panoramic views, scenic routes, and a comfortable journey ideal for nature lovers, weekend travellers, and holiday groups."
  },
  {
    "name": "Fast Cab Mumbai Saputara",
    "description": "Fast Cab Mumbai Saputara provides quick booking and rapid cab dispatch for travellers who need urgent or last-minute travel arrangements. This service ensures immediate confirmations, swift pickups, and professional drivers familiar with the fastest and safest routes to Saputara. Ideal for emergency travel, sudden plans, or quick weekend trips."
  },
  {
    "name": "Mumbai Saputara Tour Taxi",
    "description": "Mumbai Saputara Tour Taxi offers a complete tour package including sightseeing locations such as Sunset Point, Step Garden, Lake View Point, Saputara Lake, and more. This service is perfect for tourists looking for a comfortable, guided, and relaxing full-day or multi-day trip to Saputara. Custom itineraries and experienced drivers make the journey memorable."
  },
  {
    "name": "Mumbai to Saputara Round Trip",
    "description": "Mumbai to Saputara Round Trip cab service provides comfortable return journey planning with fixed pricing and reliable scheduling. Passengers can travel to Saputara, explore the hill station, and return to Mumbai comfortably in the same cab. Ideal for weekend getaways, family vacations, and short trips where convenience and reliability matter most."
  },
  {
    "name": "Corporate Cab Mumbai Saputara",
    "description": "Corporate Cab Mumbai Saputara is designed for business travellers, corporate outings, and executive travel. The service includes premium sedans, SUVs, experienced chauffeurs, and professional travel coordination. Ideal for office tours, corporate retreats, executive meetings, and intercity business travel requiring punctuality and premium comfort."
  },
  {
    "name": "Safe Cab Mumbai Saputara",
    "description": "Safe Cab Mumbai Saputara focuses on secure travel with verified drivers, GPS monitoring, clean vehicles, and well-maintained safety standards during hill-route driving. This service is ideal for solo travellers, senior citizens, and families prioritizing safety and reliability. Passengers can enjoy peace of mind throughout the long-distance journey."
  }
],

"tableData": [
  ["Mumbai Saputara Taxi", "Saputara From Mumbai Cab Booking"],
  ["Mumbai to Saputara One Way Cab", "Intercity Cab Mumbai Saputara"],
  ["Best Taxi Mumbai Saputara", "Mumbai Saputara Car Rental"],
  ["Affordable Saputara Cab", "Sedan Cab Mumbai Saputara"],
  ["SUV Cab Mumbai Saputara", "Family Cab Mumbai Saputara"],
  ["24x7 Cab Mumbai Saputara", "Mumbai Saputara Hillstation Cab"],
  ["Fast Cab Mumbai Saputara", "Mumbai Saputara Tour Taxi"],
  ["Mumbai to Saputara Round Trip", "Corporate Cab Mumbai Saputara"],
  ["Safe Cab Mumbai Saputara", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Saputara Cabs with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Saputara cab services, perfect for weekend getaways, family trips, and nature retreats with complete comfort and safety."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and well-maintained cabs to enjoy a smooth and refreshing journey from Mumbai to Saputara."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Hill Station Routes",
    "WhyChoosedescription": "Our skilled drivers are experienced with Mumbai to Saputara routes, ensuring safe driving, smooth hill travel, and timely arrivals."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included in your Mumbai to Saputara cab booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to help with bookings, itinerary planning, and travel-related assistance."
  },
  {
    "WhyChooseheading": "Flexible Travel Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized packages designed to suit your Mumbai to Saputara travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every journey to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Pickup",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making your trip from Mumbai to Saputara comfortable, enjoyable, and stress-free."
  }
]
























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Saputara?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services from Mumbai to Saputara, ensuring a smooth journey to this scenic hill station.',
  },
  {
    question: 'How can I book a cab from Mumbai to Saputara?',
    answer: 'You can easily book a cab from Mumbai to Saputara via our website, mobile app, or by calling our 24x7 customer support team for a hassle-free experience.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Saputara cab bookings?',
    answer: 'Shambhu Cabs provides a range of vehicles for the Mumbai to Saputara trip, including sedans, SUVs, luxury cars, and tempo travellers for group trips.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai to Saputara journey?',
    answer: 'Yes, our drivers are licensed, professional, and well-acquainted with the route to Saputara, ensuring a safe and comfortable ride.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations for the Mumbai to Saputara trip?',
    answer: 'Absolutely. You can select any pickup and drop-off points within Mumbai and Saputara for a more personalized and flexible travel experience.',
  },
  {
    question: 'Is the Mumbai to Saputara cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs offers 24x7 cab services for your journey from Mumbai to Saputara, ensuring you can travel at any time of the day or night.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai to Saputara trip?',
    answer: 'Yes, all vehicles are sanitized regularly, and our drivers adhere to strict safety and hygiene measures to ensure your safety throughout the journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Saputara cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for your Mumbai to Saputara cab bookings.',
  },
  {
    question: 'Is customer support available during the Mumbai to Saputara trip?',
    answer: 'Yes, Shambhu Cabs provides 24x7 customer support to assist you during your journey from Mumbai to Saputara.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Patil',
    feedback: 'Our trip from Mumbai to Saputara with Shambhu Cabs was a delight. The driver was punctual, the car was clean and comfortable, and the entire journey was smooth.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Reddy',
    feedback: 'Highly recommend Shambhu Cabs for Mumbai to Saputara trips. The service was excellent, the driver was friendly, and the trip was very relaxing.',
    rating: 5,
  },
];









































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Saputara Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-saputara-cab.jpg",
  "description": "Shambhu Cabs provides reliable Mumbai to Saputara cab services. Book affordable, premium, SUV, and sedan cabs for one-way, round trip, corporate, or family travel, available 24×7.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "890",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-saputara-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Saputara Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Saputara cab services with Shambhu Cabs. Affordable and reliable cabs including SUV, sedan, family trips, corporate travel, and round trips, available 24×7."
  />

  <meta
    name="keywords"
    content="Mumbai Saputara Taxi, Saputara From Mumbai Cab Booking, Mumbai to Saputara One Way Cab, Intercity Cab Mumbai Saputara, Best Taxi Mumbai Saputara, Mumbai Saputara Car Rental, Affordable Saputara Cab, Sedan Cab Mumbai Saputara, SUV Cab Mumbai Saputara, Family Cab Mumbai Saputara, 24x7 Cab Mumbai Saputara, Mumbai Saputara Hillstation Cab, Fast Cab Mumbai Saputara, Mumbai Saputara Tour Taxi, Mumbai to Saputara Round Trip, Corporate Cab Mumbai Saputara, Safe Cab Mumbai Saputara"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/59.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitosaputara;